import { useMutation, gql } from '@apollo/client';

export const DELETE_COMPANY_DEPARTMENT_BY_ID = gql`
  mutation deleteDepartmentById($departmentId: ObjectId!) {
    deleteDepartmentById(departmentId: $departmentId)
  }
`;

export const useDeleteCompanyDepartmentById = () => {
  const [deleteCompanyDepartmentById] = useMutation(DELETE_COMPANY_DEPARTMENT_BY_ID);

  return deleteCompanyDepartmentById;
};
